import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NavigationBar from '../../components/ui/NavigationBar';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ProfileCard from '../../components/profile-card/ProfileCard';
import QRShareRow from '../../components/profile-card/QRShareRow';
import AboutModal from '../../components/profile-card/AboutModal';
import { getPublicProfileByNesolearnId } from '../../utils/learnerProfileHelpers';

const PublicProfile = () => {
  const { nesolearnId } = useParams();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [aboutOpen, setAboutOpen] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const { profile: data } = await getPublicProfileByNesolearnId(nesolearnId);
      setProfile(data);
      setLoading(false);
    };
    load();
  }, [nesolearnId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex items-center space-x-3">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="text-muted-foreground">Loading profile...</span>
        </div>
      </div>
    );
  }

  if (!profile) {
    return (
      <div className="min-h-screen bg-background">
        <NavigationBar />
        <div className="max-w-2xl mx-auto px-4 py-24 text-center">
          <Icon name="UserX" size={40} className="text-destructive mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-foreground mb-2">Profile Not Found</h1>
          <p className="text-muted-foreground mb-6">
            No learner matches ID <span className="font-mono">{nesolearnId}</span>.
          </p>
          <Link to="/course-catalog">
            <Button variant="default">Browse Courses</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{profile?.name} ({profile?.nesolearnId}) - Nesolearn</title>
      </Helmet>

      <div className="min-h-screen bg-background">
         <NavigationBar />
        <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 pt-28 sm:pt-32 pb-12">
         <ProfileCard
            profile={profile}
            footerSlot={
              <QRShareRow
                profileUrl={`${window.location.origin}/id/${profile?.nesolearnId}`}
                nesolearnId={profile?.nesolearnId}
              />
            }
          />
           <div className="text-center mt-4">
            <button
              onClick={() => setAboutOpen(true)}
              className="text-sm text-accent hover:underline"
            >
              About this profile
            </button>
          </div>

          <p className="text-xs text-muted-foreground text-center mt-6">
            Powered by Nesolearn - the operating system for institutions delivering future-ready digital education.
          </p>
        </main>

        <AboutModal profile={profile} isOpen={aboutOpen} onClose={() => setAboutOpen(false)} />
      </div>
    </>
  );
};

export default PublicProfile;